
export default function(rows=[["name1", "city1", "some other info"], ["name2", "city2", "more info"]],name="dowload.csv"){
   
    let csvContent =  "\uFEFF"//UTF-8 BOOM;
    // The UTF-8 BOM is a sequence of bytes (EF BB BF) that allows the reader to identify a file as being encoded in UTF-8. Normally, the BOM is used to signal the endianness of an encoding, but since endianness is irrelevant to UTF-8, the BOM is unnecessary.
   
    let totalCols = rows[0].length

    rows.forEach(function(rowArray){
        let newRowContent = []
        for (let i = 0; i < totalCols; i++) {
            let colVal = _.get(rowArray,'['+i+']','');
            // colVal = replace(/[;]/g,',')
            newRowContent.push(colVal)
        }
        let row = newRowContent.join(";");
        csvContent += row + "\r\n";
    }); 
    

    var textEncoder = new TextEncoder('utf-8');
    var csvContentEncoded = textEncoder.encode([csvContent]);

    // var downloadUrl = window.DIGISUSAPI.digi_server+'downloadcsv'

    //show window
    // $('body').append('<div id="waitcsv" style="position:fixed;top:0;bottom:0;right:0;left:0;display:flex;align-items:center;justify-content:center; z-index:1000; background: rgba(0,0,0,0.4);"> <div style="background:white;border-radius:20px;padding:3em;width:300px;height:200px;"><b>Gerando arquivo, aguarde...</b></div></div>')

    // $.ajax({
    //         type: "POST",
    //         url: downloadUrl,
    //         data: JSON.stringify({conteudo:csvContent, filename:name}),
    //         contentType: "application/json",
    //         success: function(response, status, xhr) {
                        
    //                     setTimeout( ()=>{
    //                         var a = document.createElement("a");
    //                         let urlFile = window.DIGISUSAPI.digi_server+"downloadFile/?filename="+response; 
    //                         // safari doesn't support this yet
    //                         if (typeof a.download === 'undefined') {
    //                             window.location =  urlFile;
    //                         } else {
    //                             a.href = urlFile;
    //                             a.download = response;
    //                             document.body.appendChild(a);
    //                             a.click();
    //                         }  
    //                         $('#waitcsv').remove();
    //                 },1000) 
    //             },
    //             error:function(){

    //                 $('#waitcsv').remove();
    //                 alert("ocorreu um erro!")
    //             }
            
    //     });

    
    var link = document.createElement("a");
    document.body.appendChild(link);
    link.style = "display: none";
    link.setAttribute("download", name);
    
    var csvContentEncoded = textEncoder.encode([csvContent]);
    var blob = new Blob([csvContentEncoded], {type: 'text/csv;charset=utf-8;'});
    var url = window.URL.createObjectURL(blob);
    link.href = url;
    link.click(); 
    window.URL.revokeObjectURL(url);

}